import { ReactNode } from "react";
import "./LeafMessageBox.scss";

export enum LeafMessageBoxColor {
  RED = "red",
  ORANGE = "orange",
  GREEN = "green",
  BLUE = "blue",
}

type Props = {
  color: LeafMessageBoxColor;
  children: ReactNode;
};

export const LeafMessageBox = ({ children, color }: Props) => {
  return (
    <div className={`LeafMessageBox LeafMessageBox--${color}`} data-testid={`leafMessageBox`}>
      {children}
    </div>
  );
};
